import { render, staticRenderFns } from "./SettingDoctorSayInfo.vue?vue&type=template&id=3f6c6529&scoped=true&"
import script from "./SettingDoctorSayInfo.vue?vue&type=script&lang=js&"
export * from "./SettingDoctorSayInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettingDoctorSayInfo.vue?vue&type=style&index=0&id=3f6c6529&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c6529",
  null
  
)

export default component.exports